import { FC } from "preact/compat";
import { ResizeHandlerProps } from "./interfaces";
import cn from "classnames";

const ResizeHandler: FC<ResizeHandlerProps> = ({
    buttonRef,
    className,
    ...rest
}) => (
    <button
        type="button"
        ref={buttonRef}
        className={cn(
            "absolute top-1/2 z-10 block h-[64px] w-[8px] -translate-y-1/2 cursor-col-resize rounded-lg bg-gray-200 transition duration-100 hover:bg-sky-800",
            "outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 focus:ring-offset-white focus:bg-sky-800",
            className,
        )}
        {...rest}
    />
);

export default ResizeHandler;
